'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CAROUSEL_CTA_CLICKED = 'CAROUSEL_CTA_CLICKED';

exports.CAROUSEL_CTA_CLICKED = CAROUSEL_CTA_CLICKED;
